export const selectStyles = {
    control: (provided: any) => ({
        ...provided,
        boxShadow: 'none',
        '&:hover': {
        borderColor: '#D8C8B8'
        },
        '&:focus': {
        borderColor: '#D8C8B8'
        },
        '&:active': {
        borderColor: '#D8C8B8'
        }
    }),
    option: (provided:any, state: any) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#D8C8B8' : provided.backgroundColor,
        color: state.isSelected ? 'white' : provided.color,
        '&:hover': {
        backgroundColor: '#EFECE9',
        }
    })
};